// import React from 'react'
// import { Link } from 'react-router-dom';
// import ClientNavbar from '../layout/ClientNavbar';

// export default function MyInvestments({ setActiveTab }) {
//   return (
//     <div>
//       <ClientNavbar />
//       <div className="card shadow-sm p-4 mb-4 text-center">
//         <h3 className="text-primary mb-4">My Investments</h3>
//         <p className="text-muted py-5">
//           No investments yet. Start your investment journey today!
//         </p>
//         <div className="d-flex gap-2 justify-content-center">
//           <button
//             className="btn btn-primary"
//             onClick={() => setActiveTab('mutualfunds')}
//           >
//             Browse Mutual Funds
//           </button>
//           <Link to="/investment-verification/new" className="btn btn-primary">
//             Start Investment Process
//           </Link>
//         </div>
//       </div>
//     </div>
//   )
// }



import React from "react";
import { Link } from "react-router-dom";
import ClientNavbar from "../layout/ClientNavbar";

export default function MyInvestments({ setActiveTab }) {
  return (
    <div className="container-fluid">
      <div className="row min-vh-100">
        {/* Sidebar */}
        <div className="col-md-2 p-0">
          <ClientNavbar />
        </div>

        {/* Main Content */}
        <div
          className="col-md-10 d-flex align-items-center justify-content-center"
          style={{
            background:
              "linear-gradient(135deg, rgb(240, 253, 253) 0%, rgba(155, 222, 218, 0.73) 50%, rgb(3, 186, 187) 100%)",
            minHeight: "100vh",
            padding: "2rem",
          }}
        >
          <div className="card shadow-sm p-4 text-center w-100" style={{ maxWidth: "600px" }}>
            <h3 className="text-primary mb-4">My Investments</h3>
            <p className="text-muted py-5">
              No investments yet. Start your investment journey today!
            </p>
            <div className="d-flex gap-2 justify-content-center flex-wrap">
              <button
                className="btn btn-primary"
                onClick={() => setActiveTab("mutualfunds")}
              >
                Browse Mutual Funds
              </button>
              <Link to="/investment-verification/new" className="btn btn-primary">
                Start Investment Process
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
